import React from 'react';
import { View } from 'react-native';
import { scale } from '@components/frame';

export default ({ color }) => {
  return Array.from({ length: 20 }, (_, i) => i).map((i) => (
    <View
      key={'line-' + i}
      style={{
        width: '500%',
        marginLeft: '-250%',
        height: scale(3),
        backgroundColor: color,
        marginBottom: scale(6),
        transform: [{ rotate: '-45deg' }],
      }}
    />
  ));
};
